import React, { RefObject } from 'react';

import classes from './MCard.module.scss';
import { condClass } from 'app/utils/general';

interface Props {
  className?: string;
  containerRef?: RefObject<HTMLDivElement> | null;
}

const MCardView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div ref={props.containerRef} className={condClass({ [classes['container']]: true, [String(props.className)]: !!props.className })}>
      {props.children}
    </div>
  );
};

MCardView.displayName = 'MCardView';
MCardView.defaultProps = {};

export default MCardView;
